import { Typography, TypographyProps } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface IText extends TypographyProps {
  children: string;
}

const Text = (props: IText) => {
  const { children } = props;
  const { t } = useTranslation();

  return <Typography {...props}>{t(children) || ""}</Typography>;
};

export default memo(Text);
